import { Axios } from 'axios';
import apiClient from 'services/api/axios';
// import { IVMResBody } from 'store/virtual-machine/types/api-bodies.types';
import {
  IGetLBsDto, IGetLBByIdDto, ICheckVMHasLoadBalancer, ICheckVMAndNetForLoadBalancer,
  ICheckNodePoolForLoadBalancer, ICheckAsgForLoadBalancer, IAttachableBackendGroupsRes,
} from 'components/Loadbalancers/types/dtos';
import { ILBCreateForm, ILBEditForm } from 'components/Loadbalancers/types/index';
import { IReservedPublicIpsResponse } from 'store/network/types/api-bodies.types';

class LBService {
  api: Axios;

  constructor(api: Axios) {
    this.api = api;
  }

  createLB(body: ILBCreateForm) {
    return this.api.post<IGetLBByIdDto>('/loadbalancer/createLoadbalancer', body);
  }

  getLB(loadBalancerId: number) {
    return this.api.get<IGetLBByIdDto>(`/loadbalancer/getLoadBalancer?loadBalancerId=${loadBalancerId}`);
  }

  getLBList() {
    return this.api.get<IGetLBsDto>('/loadbalancer/getUserLoadBalancers');
  }

  editLB(lbId: number, body: ILBEditForm) {
    return this.api.post<IGetLBByIdDto>(`/loadbalancer/configureLoadbalancer/${lbId}`, body);
  }

  // keepPublicIp — оставить публичный IP за собой; не передан — бэкенд закрепление не трогает
  deleteLB(lbId: number, keepPublicIp?: boolean) {
    return this.api.post(`/loadbalancer/deleteLoadbalancer/${lbId}`, null, { params: { keepPublicIp } });
  }

  getReservedPublicIps() {
    return this.api.get<IReservedPublicIpsResponse>('/loadbalancer/reservedPublicIps');
  }

  checkVMForLoadbalancer(vmId: number | string) {
    return this.api.get<ICheckVMHasLoadBalancer>(`/loadbalancer/checkVMForLoadBalancer/${vmId}`);
  }

  deleteVmForLoadBalancerBackend(vmId: number | string) {
    return this.api.post(`/loadbalancer/deleteVmForLoadBalancerBackend/${vmId}`);
  }

  checkVMAndNetForLoadBalancer(vmId: string, userNetId: number) {
    return this.api.get<ICheckVMAndNetForLoadBalancer>(`/loadbalancer/checkVMAndNetForLoadBalancer/${vmId}?userNetId=${userNetId}`);
  }

  checkNodePoolForLoadBalancer(nodePoolId: number) {
    return this.api.get<ICheckNodePoolForLoadBalancer>(`/loadbalancer/checkNodePoolForLoadBalancer/${nodePoolId}`);
  }

  // Группы автомасштабирования и пулы нод всех кластеров этой сети одним списком.
  // Фильтр по сети обязателен: с чужой сетью бэкенд отвечает 633.
  getAttachableBackendGroups(userNetId: number) {
    return this.api.get<IAttachableBackendGroupsRes>(`/loadbalancer/attachableBackendGroups?userNetId=${userNetId}`);
  }

  checkAsgForLoadBalancer(asgId: number) {
    return this.api.get<ICheckAsgForLoadBalancer>(`/loadbalancer/checkAsgForLoadBalancer/${asgId}`);
  }

  deleteBackendsForAsg(asgId: number) {
    return this.api.post(`/loadbalancer/deleteBackendsForAsg/${asgId}`);
  }

  deleteBackendsForNodePool(nodePoolId: number) {
    return this.api.post(`/loadbalancer/deleteBackendsForNodePool/${nodePoolId}`);
  }

  deleteLbForKuber(clusterId: number) {
    return this.api.post(`/loadbalancer/deleteLbForKuber/${clusterId}`);
  }
}

export default new LBService(apiClient);
